<template>
  <div
    class="overflow-hidden pb-10 md:px-0 max-w-screen-2xl mx-auto flex flex-col items-center"
  >
    <div class="flex mx-auto justify-center">
      <div class="w-full">
        <progress-bar :percentage="durationPercentage" />
        <div class="mt-14 lg:mt-10">
          <div @click="goToOngoingTransaction">
            <pending-transaction-count v-if="active === 0" />
          </div>
          <deposit-method-dropdown
            class="w-11/12 lg:w-9/12 mx-auto pb-3"
            v-if="active === 0"
          />
          <enter-amount
            v-if="active === 0"
            @next="next"
            @showMakePayment="goToMakePayment"
            class="w-11/12 lg:w-9/12 mx-auto border border-solid border-gray-50 rounded-2xl px-2 lg:px-6 pb-4"
            @prev="prev"
          />
          <transition name="fade-in" mode="out-in">
            <component
              :is="currentComponent"
              @next="next"
              @prev="prev"
              @showMakePayment="goToMakePayment"
              @toReview="toReview"
              @editTransfer="editTransfer"
              @toFirstPage="toFirstPage"
              @goToEnterAmount="toEnterAmount"
              @updateAssetTransferDetails="updateAssetTransferDetails"
              formType="new recipient"
              :class="{
                'w-11/12 lg:w-9/12 mx-auto border border-solid border-gray-50 rounded-2xl px-2 lg:px-6 pb-4':
                  active === 0
              }"
            />
          </transition>
        </div>
      </div>
    </div>
    <div class="w-full" ref="transactionRef">
      <transactions v-if="active === 0" class="mt-10" />
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      active: 0,
      ref: null,
      components: ['recipient', 'review-information', 'make-payment']
    }
  },
  methods: {
    goToOngoingTransaction () {
      this.$refs.transactionRef.scrollIntoView({ behavior: 'smooth' })
    },
    format () {
      return ''
    },
    next () {
      this.active++
    },
    goToMakePayment () {
      this.active = 3
    },
    prev () {
      this.active--
    },
    goBack () {
      this.$emit('terminalPage')
    },
    toTransferDetails () {
      this.active = 1
    },
    toFirstPage () {},
    // changeUserDetails () {
    //   this.active--
    //   this.scroll()
    // },
    toReview () {
      this.active = 2
    },
    editTransfer () {
      this.active = 0
    },
    toEnterAmount () {
      this.active = 0
    },
    // changeBank () {
    //   this.active--
    // },
    updateAssetTransferDetails () {
      this.active = 0
    }
  },
  computed: {
    currentComponent () {
      return this.components[this.active - 1]
    },
    durationPercentage () {
      if (!this.fromBalance) {
        return this.active !== 3 ? (this.active + 0.05) * 33.3 : 100
      } else {
        return this.active !== 2 ? (this.active + 0.05) * 50 : 100
      }
    },
    fromBalance () {
      return this.$store.state.terminal.terminalTransferType === 'fromBalance'
    }
    // TransactionStatus () {
    // return this.statusType === this.$STATUS.PENDING
    // return this.transactionDetails.status === this.$STATUS.PENDING
    // }
  },
  components: {
    Transition: () =>
      import('@/components/v2/animation/transition/Transition.vue'),
    EnterAmount: () =>
      import(
        '@/components/v2/terminal/layout/terminalSkeleton/EnterAmount.vue'
      ),
    Recipient: () =>
      import(
        '@/components/v2/terminal/layout/terminalSkeleton/recipient/RecipientDetails.vue'
      ),
    ReviewInformation: () =>
      import(
        '@/components/v2/terminal/layout/terminalSkeleton/ReviewInformation.vue'
      ),
    MakePayment: () =>
      import(
        '@/components/v2/terminal/layout/terminalSkeleton/makePayment/index.vue'
      ),
    ProgressBar: () =>
      import(
        '@/components/v2/terminal/layout/terminalSkeleton/ProgressBar.vue'
      ),
    PendingTransactionCount: () =>
      import(
        '@/components/v2/terminal/layout/terminalSkeleton/TransactionCount.vue'
      ),
    Transactions: () =>
      import('@/components/v2/terminal/layout/Transactions.vue'),
    DepositMethodDropdown: () =>
      import(
        '@/components/v2/terminal/layout/terminalSkeleton/holdingsFlow/DepositMethodDropdown.vue'
      )
  }
}
</script>

<style scoped>
>>> .el-progress-bar__inner {
  background: var(--color-primary);
}
>>> .el-progress-bar {
  width: 107%;
}
</style>
